
define('tpl!taoQtiItem/qtiCreator/tpl/toolbars/table', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression;


  buffer += "<div class=\"mini-tlb\" data-edit=\"";
  if (helper = helpers.state) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.state); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-for=\"";
  if (helper = helpers.serial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.serial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    <div class=\"rgt tlb-button\" data-role=\"cke-launcher\" title=\"Formatting options\">\n        <span class=\"icon-font\"></span>\n    </div>\n    <div class=\"rgt tlb-button\" title=\"Delete\" data-role=\"delete\">\n        <span class=\"icon-bin\"></span>\n    </div>\n    <div class=\"rgt tlb-button\" data-role=\"cke-table-properties\" title=\"Table properties\">\n        <span class=\"icon-table\"></span>\n    </div>\n</div>\n";
  return buffer;
  });
});

